import React from 'react';

import styled from 'styled-components';

import { ComingSoonBenefit } from 'types/comingSoonFeatures';

import { MutedText, Row } from './ComingSoonStyles';

const BenefitIcon = styled.div`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  border-radius: 50%;
  background: var(--white-60);
  font-size: 18px;
`;

const BenefitTitle = styled.div`
  font-family: var(--font-bold);
`;

type Props = {
  benefits: ComingSoonBenefit[];
};

const ComingSoonBenefits = ({ benefits }: Props) => (
  <Row>
    {benefits.map(({ icon: Icon, title, text }) => (
      <div key={title}>
        <BenefitIcon>
          <Icon />
        </BenefitIcon>
        <BenefitTitle>{title}</BenefitTitle>
        <MutedText>{text}</MutedText>
      </div>
    ))}
  </Row>
);

export default ComingSoonBenefits;
